import { render, staticRenderFns } from "./ItemWave1.vue?vue&type=template&id=0463d360&scoped=true&"
import script from "./ItemWave1.vue?vue&type=script&lang=js&"
export * from "./ItemWave1.vue?vue&type=script&lang=js&"
import style0 from "./ItemWave1.vue?vue&type=style&index=0&id=0463d360&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463d360",
  null
  
)

export default component.exports